export default __webpack_public_path__ + "lines_tablet.aee3d206.png";